import React, { Fragment, useEffect, useState } from 'react';
import { css, DefaultButton, DocumentCard, DocumentCardPreview, FontIcon, ICommandBarItemProps, IContextualMenuItem, IContextualMenuProps, IDocumentCardPreviewImage, IDocumentCardPreviewProps, ITooltipHostStyles, mergeStyles, mergeStyleSets, Text, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import { IAttachmentPecMail, IFile, IMailPecMail } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import axios, { CancelTokenSource } from 'axios';
import { reduxActions, RootState } from '../../store';
import { matchPath, RouteComponentProps, withRouter } from 'react-router-dom';
import pecmailService from '../../services/pecmail.service';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { useBoolean } from '@fluentui/react-hooks';
import DOMPurify from "dompurify";
import { store } from '../..';
import { myTheme } from '../../assets/styles/my-theme';
import Utilities from '../../shared/Utilities/utilities';
import CustomCommandButton from '../CustomFluentUI/CustomCommandButton/CustomCommandButton';
import { MailProtocolWizardReduxState } from '../../store/mail-protocol-wizard/types';
import { connect, ConnectedProps } from 'react-redux';


const queryString = require('query-string');

const folderTreePathString = "/:aooId/pecmail/:mailboxAddress";
const mailListItemsPathString = "/:aooId/pecmail/:mailboxAddress/:folderId";
const mailItemViewerPathString = "/:aooId/pecmail/:mailboxAddress/:folderId/:mailId";

const { palette } = myTheme;

const classNames = mergeStyleSets({
    // Applied to make content overflow (and tooltips activate)
    overflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: 'block' },
};

const mapState = (state: RootState) => ({
    selectedMail: state.mailProtocolWizardReducer.selectedMail
})

const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>
export interface PecMailItemViewerProps {

}
type Props = PecMailItemViewerProps & RouteComponentProps & PropsFromRedux

let cancelTokenSources = {};


const PecMailItemViewer: React.FunctionComponent<Props> = props => {

    const [loading, { setTrue: showLoader, setFalse: hideLoader }] = useBoolean(true);
    const [mail, setMail] = React.useState<IMailPecMail>();

    const [selectedAooId, setSelectedAooId] = useState<string | undefined>();
    const [selectedMailboxAddress, setSelectedMailboxAddress] = useState<string | undefined>();
    const [selectedFolderId, setSelectedFolderId] = useState<string | undefined>();
    const [selectedMailId, setSelectedMailId] = useState<string | undefined>();


    const domPurifyProps = {
        FORBID_TAGS: ['head']
    };

    useEffect(() => {
        // Anything in here is fired on component mount.


        return () => {
            // Anything in here is fired on component unmount.

            // cancello tutte le request in pending
            for (const [key, value] of Object.entries<CancelTokenSource>(cancelTokenSources)) {
                value.cancel(`${key} canceled`)
            }

        }
    }, [])

    useEffect(() => {

        getParamsValuesFromUrl();

    }, [props.location.pathname]);


    useEffect(() => {
        setMail(props.selectedMail);

    }, [props.selectedMail]);

    useEffect(() => {
        if (!props.selectedMail) {
            getMail();
        }
    }, [selectedMailId]);

    const getParamsValuesFromUrl = () => {
        const { location } = props;

        // Uso matchPath per prendere i parametri dai path dei component figli

        const matchFolderTreePath = matchPath(location.pathname, {
            path: folderTreePathString,
            exact: true
        })
        if (matchFolderTreePath) {
            setSelectedAooId(matchFolderTreePath.params['aooId']);
            setSelectedMailboxAddress(matchFolderTreePath.params['mailboxAddress']);
        }
        const matchMailListItemsPath = matchPath(location.pathname, {
            path: mailListItemsPathString,
            exact: true
        })
        if (matchMailListItemsPath) {
            setSelectedAooId(matchMailListItemsPath.params['aooId']);
            setSelectedMailboxAddress(matchMailListItemsPath.params['mailboxAddress']);
            setSelectedFolderId(matchMailListItemsPath.params['folderId']);
        }
        const matchMailItemViewerPathString = matchPath(location.pathname, {
            path: mailItemViewerPathString,
            exact: true
        })
        if (matchMailItemViewerPathString) {
            setSelectedAooId(matchMailItemViewerPathString.params['aooId']);
            setSelectedMailboxAddress(matchMailItemViewerPathString.params['mailboxAddress']);
            setSelectedFolderId(matchMailItemViewerPathString.params['folderId']);
            setSelectedMailId(matchMailItemViewerPathString.params['mailId']);
        }
    }
    const onAttachmentClick = (attachment: IAttachmentPecMail) => {
        const parsedQueryString = queryString.parse(props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;
        if (selectedAooId && uorId && selectedMailboxAddress && selectedMailId) {
            let aooId: number = Number(selectedAooId);

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            cancelTokenSources[attachment.url]?.cancel("Request annullata");
            cancelTokenSources[attachment.url] = axios.CancelToken.source();

            pecmailService.getBase64FromUrl(aooId, uorId, selectedMailboxAddress, attachment.url, cancelTokenSources[attachment.url].token)
                .then(result => {
                    Utilities.SaveFileFromBase64(result, attachment.nomeFile);
                });



        }
    }
    const getMail = () => {
        const parsedQueryString = queryString.parse(props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        if (selectedAooId && uorId && selectedMailboxAddress && selectedMailId) {

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            cancelTokenSources[pecmailService.getMailById.name]?.cancel("Request annullata");
            cancelTokenSources[pecmailService.getMailById.name] = axios.CancelToken.source();

            showLoader();

            pecmailService.getMailById(selectedAooId, uorId, selectedMailboxAddress, selectedMailId, true, cancelTokenSources[pecmailService.getMailById.name].token)
                .then(result => {
                    setMail(result);
                    hideLoader();
                    store.dispatch(reduxActions.mailProtocolWizardActions.updateMailProtocolWizardState({ selectedMail: result }))
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    } else {
                        setMail(undefined);
                        store.dispatch(reduxActions.mailProtocolWizardActions.updateMailProtocolWizardState({ selectedMail: undefined }))
                        hideLoader()

                        throw error;
                    }




                });

        }

    }

    if (mail) {
        // Esempi di sanitize
        //DOMPurify.sanitize('<img src=x onerror=alert(1)//>'); // becomes <img src="x">
        //DOMPurify.sanitize('<svg><g/onload=alert(2)//<p>'); // becomes <svg><g></g></svg>
        //DOMPurify.sanitize('<p>abc<iframe//src=jAva&Tab;script:alert(3)>def</p>'); // becomes <p>abc</p>
        //DOMPurify.sanitize('<math><mi//xlink:href="data:x,<script>alert(4)</script>">'); // becomes <math><mi></mi></math>
        //DOMPurify.sanitize('<TABLE><tr><td>HELLO</tr></TABL>'); // becomes <table><tbody><tr><td>HELLO</td></tr></tbody></table>
        //DOMPurify.sanitize('<UL><li><A HREF=//google.com>click</UL>'); // becomes <ul><li><a href="//google.com">click</a></li></ul>
        const mySafeHTML = DOMPurify.sanitize(mail.body, domPurifyProps);


        let attachments = mail.allegati.filter(el => el.tipologia === 'Allegato');
        let menuItems: IContextualMenuItem[] = [];
        attachments.forEach(el => {
            menuItems.push({
                key: el.nomeFile,
                text: el.nomeFile,
                data: el,
                onClick: () => onAttachmentClick(el)

            });
        });
        const menuProps: IContextualMenuProps = {
            items: menuItems

        };

        return (
            <React.Fragment>
                <div className="mail-head">
                    <div className="title-infobtn-container">
                        <TooltipHost
                            hostClassName={classNames.overflow}
                            content={mail.subject}
                            styles={hostStyles}
                        >
                            <Text className="mail-title" nowrap>
                                {mail.subject}
                            </Text>
                        </TooltipHost>

                    </div >
                    <div className="mail-info-actions-container">
                        <div className="mail-info">
                            <Text className="mail-from" nowrap>
                                {mail.from}
                            </Text>
                            <Text className="mail-datetime" nowrap>
                                {AppUtilities.FormatDate(mail.date, false)}
                            </Text>

                            <Text className="mail-dest" nowrap>
                                A: {mail.to.map(el => el.email + "; ")}
                            </Text>

                            {
                                mail.cc && mail.cc.length > 0 &&
                                <Text className="mail-dest" nowrap>
                                    Cc: {mail.cc.map(el => el.email + "; ")}
                                </Text>

                            }

                        </div>

                        <div className="mail-actions">
                            <div className="actions">
                                {attachments && attachments.length > 0 &&
                                    <CustomCommandButton
                                        text={attachments.length.toString()}
                                        menuProps={menuProps}
                                        iconPropFontAwesome={{ icon: ['fal', 'paperclip'] }}

                                    />

                                }
                            </div>
                            <div className="actions">
                                {/*    <DefaultButton*/}
                                {/*        text="Standard"*/}
                                {/*        split*/}
                                {/*        splitButtonAriaLabel="See 2 options"*/}
                                {/*        aria-roledescription="split button"*/}
                                {/*        menuProps={{*/}
                                {/*            items: [*/}
                                {/*                {*/}
                                {/*                    key: 'RispondiATutti',*/}
                                {/*                    text: 'Rispondi a tutti',*/}
                                {/*                    iconProps: { iconName: 'Reply' },*/}
                                {/*                },*/}
                                {/*                {*/}
                                {/*                    key: 'Rispondi',*/}
                                {/*                    text: 'Rispondi',*/}
                                {/*                    iconProps: { iconName: 'ReplyAll' },*/}
                                {/*                },*/}
                                {/*                {*/}
                                {/*                    key: 'Inoltra',*/}
                                {/*                    text: 'Inoltra',*/}
                                {/*                    iconProps: { iconName: 'ReplyAlt' },*/}
                                {/*                },*/}
                                {/*            ],*/}
                                {/*        }}*/}
                                {/*    />*/}
                            </div>
                        </div>
                    </div>

                </div>
                <hr className="mail-head-hr" />

                <div className="mail-body-wrapper position-relative">
                    <div className={`position-relative my-scroll-div`}>
                        <div className="mail-body-content">
                            <div dangerouslySetInnerHTML={{ __html: mySafeHTML }} />
                        </div>
                    </div>
                </div>
                {
                    attachments && attachments.length > 0 && attachments.length <= 3 &&
                    <React.Fragment >
                        <hr className="mail-head-hr" />
                        <div className="mail-attachments" >
                        </div >
                    </React.Fragment >
                }
            </React.Fragment>

        );
    }
    else
        return (
            <div className={`position-relative`}>

                <CircleLoader loaderClass='loader-large' loading={loading} />
                <div className='no-mail' >
                    <span>
                        <FontIcon iconName="Mail" className={mergeStyles({
                            fontSize: 80,
                            height: 80,
                            width: 80,
                            margin: '0 25px',
                            color: palette.themePrimary
                        })} /></span>
                    <span>Seleziona un elemento da leggere</span>
                </div>
            </div >
        );

}
export default withRouter(PecMailItemViewer);
